import { Button, Tooltip } from '@customerio/pluma-components/react';
import type { Collection } from '@/services/db/collection/entity';
import { useCollectionDelete } from './use-collection-delete';

type DeleteCollectionButtonProps = {
  collection: Collection;
  workspaceId: number;
  canDelete: boolean;
  onDeleted: (() => void) | undefined;
};

export function DeleteCollectionButton({ collection, workspaceId, canDelete, onDeleted }: DeleteCollectionButtonProps) {
  const { requestDelete, inUseTooltip } = useCollectionDelete({ workspaceId, onDeleted });

  return (
    <Tooltip content={inUseTooltip} placement="top" isDisabled={!collection.in_use} isCustom={true}>
      {(context) => (
        <Button
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
          variant="secondary"
          isDanger
          isDisabled={!canDelete || collection.importing || collection.in_use}
          onClick={() => void requestDelete(collection)}
        >
          Delete collection
        </Button>
      )}
    </Tooltip>
  );
}
